<template>
  <div class="customers-table round-borders">
    <q-scroll-area
      class="full-width customers-table__scroll"
      :thumb-style="{
        width: '5px',
        'background-color': '#555',
        opacity: 1
      }"
    >
        <q-infinite-scroll class="full-width" :handler="handleInfiniteScroll" :offset="300" ref="infiniteScroll">

        <div v-for="customer in customers" :key="customer.id">
          <component
            :is="rows[customer.type]"
            :customer="customer"
            @openUpdateModal="handleModalOpen"
          />
        </div>

        <div slot="message" class="row justify-center">
          <q-spinner-dots name="dots" :size="40"></q-spinner-dots>
        </div>
      </q-infinite-scroll>
    </q-scroll-area>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import CompanyTableEntry from './Companies/CompanyTableEntry.vue'
  import PersonTableEntry from './Persons/PersonTableEntry.vue'

  export default {
    computed: mapGetters(['customers']),

    methods: {
      ...mapActions(['fetchNextCustomersChunk']),

      handleInfiniteScroll (index, done) {
        this.fetchNextCustomersChunk(done)
      },

      handleModalOpen (customer) {
        this.$refs.customerModal.open(customer)
      }
    },

    data () {
      return {
        rows: {
          person: PersonTableEntry,
          company: CompanyTableEntry
        }
      }
    },

    components: {
      PersonTableEntry,
      CompanyTableEntry
    }
  }
</script>

<style src="./styles/customers-table.styl" lang="stylus"></style>
